import React from 'react';

export const Evolution: React.FC = () => {
  return <div />;
};
